import React from "react";
import { useSelector } from "react-redux";
import { useHomeBannersFetch } from "../../../hooks/useHomeBannersFetch";

const DiscountedProduct = () => {
  const { offerBanners } = useSelector((state) => state.banner);
  useHomeBannersFetch();
  return (
    <section className="discount pt-10">
      <div className="container container-lg">
        <div className="row gy-4">
          {offerBanners?.map((banner) => {
            return (
              <div className="col-xl-6">
                <div
                  className="discount-item rounded-16 overflow-hidden position-relative z-1 d-flex flex-column align-items-start justify-content-center"
                  style={{ height: "300px" }}>
                  <img
                    src={banner.image}
                    alt=""
                    className="position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 z-n1"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DiscountedProduct;
